Ext.define('PanelWizardFilterUkladNapelniany', {
    extend: 'Ext.panel.Panel',
    initComponent: function () {
        this.cid = Ext.id();
        Ext.apply(this, {
            layout: "fit",
            frame: false,
            border: false,
            autoWidth: false,
            autoHeight: false,
            items: [{
                xtype: 'form',
                frame: false,
                border: false,
                autoWidth: true,
                autoHeight: true,
                bodyStyle: 'padding:10px 10px 10px 10px',
                defaults: {
                    anchor: "0"
                },
                id: this.cid + "formpanel",
                labelWidth: 100,
                items: [{
                    anchor: "0",
                    layout: 'column',
                    frame: false,
                    border: false,
                    items: [{
                        columnWidth: 1.0,
                        layout: 'form',
                        labelWidth: 100,
                        defaults: {
                            anchor: "0"
                        },
                        frame: false,
                        border: false,
                        items: [{
                            id: this.cid + "SILNIK",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.uklad_napelniany[0].capitalise()
                        }, {
                            id: this.cid + "DOZOWNIK_OLEJU",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.uklad_napelniany[1].capitalise()
                        }, {
                            id: this.cid + "NAPED_WENTYLATORA",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.uklad_napelniany[2].capitalise()
                        }, {
                            id: this.cid + "SKRZYNIA_BIEGOW",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.uklad_napelniany[3].capitalise()
                        }, {
                            id: this.cid + "MOST_NAPEDOWY",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.uklad_napelniany[4].capitalise()
                        }, {
                            id: this.cid + "UKLAD_CHLODZENIA",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.uklad_napelniany[5].capitalise()
                        }, {
                            id: this.cid + "UKLAD_HYDRAULICZNY",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.uklad_napelniany[6].capitalise()
                        }, {
                            id: this.cid + "SPRYSKIWACZ_SZYB",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.uklad_napelniany[7].capitalise()
                        }, {
                            id: this.cid + "POGOTOWIE_TECHNICZNE",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.uklad_napelniany[8].capitalise()
                        }, {
                            id: this.cid + "PALIWOWY",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.uklad_napelniany[9].capitalise()
                        }]
                    }]
                }]
            }]
        });
        this.callParent(arguments);
    },
    callAfterShow: function () {
        var t0 = Ext.getCmp(this.cid + "SILNIK");
        var t1 = Ext.getCmp(this.cid + "DOZOWNIK_OLEJU");
        var t2 = Ext.getCmp(this.cid + "NAPED_WENTYLATORA");
        var t3 = Ext.getCmp(this.cid + "SKRZYNIA_BIEGOW");
        var t4 = Ext.getCmp(this.cid + "MOST_NAPEDOWY");
        var t5 = Ext.getCmp(this.cid + "UKLAD_CHLODZENIA");
        var t6 = Ext.getCmp(this.cid + "UKLAD_HYDRAULICZNY");
        var t7 = Ext.getCmp(this.cid + "SPRYSKIWACZ_SZYB");
        var t8 = Ext.getCmp(this.cid + "POGOTOWIE_TECHNICZNE");
        var t9 = Ext.getCmp(this.cid + "PALIWOWY");
        var bbem = this.datad.mainCtrl.repDef.typyUkladow.length == 0;
        t0.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyUkladow, Const.NAPELNIANY_UKLAD_SILNIK) || bbem);
        t1.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyUkladow, Const.NAPELNIANY_UKLAD_DOZOWNIK_OLEJU) || bbem);
        t2.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyUkladow, Const.NAPELNIANY_UKLAD_NAPED_WENTYLATORA) || bbem);
        t3.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyUkladow, Const.NAPELNIANY_UKLAD_SKRZYNIA_BIEGOW) || bbem);
        t4.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyUkladow, Const.NAPELNIANY_UKLAD_MOST_NAPEDOWY) || bbem);
        t5.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyUkladow, Const.NAPELNIANY_UKLAD_UKLAD_CHLODZENIA) || bbem);
        t6.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyUkladow, Const.NAPELNIANY_UKLAD_UKLAD_HYDRAULICZNY) || bbem);
        t7.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyUkladow, Const.NAPELNIANY_UKLAD_SPRYSKIWACZ_SZYB) || bbem);
        t8.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyUkladow, Const.NAPELNIANY_UKLAD_POGOTOWIE_TECHNICZNE) || bbem);
        t9.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyUkladow, Const.NAPELNIANY_UKLAD_PALIWOWY) || bbem);
        this.callAfterShowCalled = true;
    },
    callAfterHide: function () {
        if (this.callAfterShowCalled) {
            var t0 = Ext.getCmp(this.cid + "SILNIK");
            var t1 = Ext.getCmp(this.cid + "DOZOWNIK_OLEJU");
            var t2 = Ext.getCmp(this.cid + "NAPED_WENTYLATORA");
            var t3 = Ext.getCmp(this.cid + "SKRZYNIA_BIEGOW");
            var t4 = Ext.getCmp(this.cid + "MOST_NAPEDOWY");
            var t5 = Ext.getCmp(this.cid + "UKLAD_CHLODZENIA");
            var t6 = Ext.getCmp(this.cid + "UKLAD_HYDRAULICZNY");
            var t7 = Ext.getCmp(this.cid + "SPRYSKIWACZ_SZYB");
            var t8 = Ext.getCmp(this.cid + "POGOTOWIE_TECHNICZNE");
            var t9 = Ext.getCmp(this.cid + "PALIWOWY");
            this.datad.mainCtrl.repDef.typyUkladow = [];
            if (t0.getValue())
                this.datad.mainCtrl.repDef.typyUkladow.push(Const.NAPELNIANY_UKLAD_SILNIK);
            if (t1.getValue())
                this.datad.mainCtrl.repDef.typyUkladow.push(Const.NAPELNIANY_UKLAD_DOZOWNIK_OLEJU);
            if (t2.getValue())
                this.datad.mainCtrl.repDef.typyUkladow.push(Const.NAPELNIANY_UKLAD_NAPED_WENTYLATORA);
            if (t3.getValue())
                this.datad.mainCtrl.repDef.typyUkladow.push(Const.NAPELNIANY_UKLAD_SKRZYNIA_BIEGOW);
            if (t4.getValue())
                this.datad.mainCtrl.repDef.typyUkladow.push(Const.NAPELNIANY_UKLAD_MOST_NAPEDOWY);
            if (t5.getValue())
                this.datad.mainCtrl.repDef.typyUkladow.push(Const.NAPELNIANY_UKLAD_UKLAD_CHLODZENIA);
            if (t6.getValue())
                this.datad.mainCtrl.repDef.typyUkladow.push(Const.NAPELNIANY_UKLAD_UKLAD_HYDRAULICZNY);
            if (t7.getValue())
                this.datad.mainCtrl.repDef.typyUkladow.push(Const.NAPELNIANY_UKLAD_SPRYSKIWACZ_SZYB);
            if (t8.getValue())
                this.datad.mainCtrl.repDef.typyUkladow.push(Const.NAPELNIANY_UKLAD_POGOTOWIE_TECHNICZNE);
            if (t9.getValue())
                this.datad.mainCtrl.repDef.typyUkladow.push(Const.NAPELNIANY_UKLAD_PALIWOWY);
        }
        return null;
    },
    setData: function (datad) {
        this.datad = datad;
    }
});
